import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'
import Recipe from '../pages/Recipe.vue'
import Admin from '../pages/Admin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin/clementinepoutine',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/:isTiktokView',
    name: 'HomeTiktok',
    component: Home
  },
  {
    path: '/recipe/:id',
    name: 'Recipe',
    component: Recipe
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router